<template>
  <div class="view-collect">
    <el-card class="card">
      <div slot="header"
           class="clearfix">
        <span>{{$t('home.viewsel')}}</span>
      </div>
      <div class="btns">
        <div>
          <el-button type="primary" size="mini" @click="open">{{ $t('instrData.add') }}</el-button>
          <el-button type="primary" size="mini" :disabled="canEdit" @click="edit">重命名</el-button>
          <el-button type="primary" size="mini" :disabled="canDel" @click="deletes">{{ $t('modelProcess.del') }}</el-button>
        </div>
        <el-button type="primary" size="mini" :disabled="canEdit" @click="setValue">默认视角</el-button>
      </div>
      <div v-if="viewList" class="view-main">
        <div class="view"
            v-for="(i, index) in viewList"
            :class="i.checked?'checked-file':''"
            :key="index">
          <img @click="previewClick(i)" :src="i.imgPath" alt="">
          <span @click="previewClick(i)" class="view-name">{{i.vName}}{{i.isDefault?'(默认)':''}}</span>
          <span class="view-check">
            <i @click="checkedViews(i.id)"
              v-if="!i.checked"
              class="iconfont icon-sp_uncheck"></i>
            <i @click="checkedViews(i.id)"
              class="iconfont icon-sp_checked"
              v-if="i.checked"></i>
          </span>
        </div>
      </div>
      <div v-else class="view-nodata">
        <span>{{ $t('docMgt.noData') }}</span>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'viewCollect',
  data() {
    return {
      viewList: null,
      currentIndex: null,
      selectedViewList: null,
      selectedView: null,
      canDel: true,
      canEdit: true,
      viewName: ''
    }
  },
  watch: {
    selectedView(val) {
      if (val.length === 0) {
        this.canDel = true
        this.canEdit = true
      } else if (val.length > 1) {
        this.canEdit = true
      } else {
        this.canDel = false
        this.canEdit = false
      }
    }
  },
  created() {
    this.getViewList()
  },
  methods: {
    setValue() {
      console.log(this.selectedViewList)
      ApiService.views.setDefault({
        id: this.selectedView[0]
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '已设为默认'
          })
          window.R_config.initView = this.selectedViewList[0].position
          // window.SetView(this.selectedViewList[0].Position)
          this.getViewList()
        }
      })
    },
    open() {
      this.$prompt('请输入视角名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\s\S]$/,
        inputErrorMessage: '至少一个字符'
      }).then(({ value }) => {
        window.ResetAllElement()
        ApiService.views.addView({
          id: 0,
          vName: value,
          position: window.GetView(),
          imgPath: window.GetImg(0.5),
          mileageID: window.R_config.modelId,
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.getViewList()
          }
        })
      }).catch(() => {
      })
    },
    edit() {
      this.$prompt('请输入新名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\s\S]$/,
        inputErrorMessage: '至少一个字符',
        inputValue: this.viewName
      }).then(({ value }) => {
        this.editView(value)
      }).catch(() => {
      })
    },
    checkedViews(val) {
      let a = []
      let b = []
      this.viewList.map(n => {
        if (n.id === val) {
          n.checked = !n.checked
        }
        if (n.checked) {
          a.push(n.id)
          this.viewName = n.vName
          b.push(n)
        } else if (a.length !== 0 && n.checked) {
          a.remove(n.id)
          a.remove(n.vname)
          b.remove(n)
        }
      })
      this.selectedView = a
      this.selectedViewList = b
    },
    getViewList() {
      ApiService.views.getViewList({
        mileageID: window.R_config.modelId,
      }).then(res => {
        if (res.code === 0) {
          res.data.map(n => {
            n.checked = false
          })
          this.viewList = res.data
        } else {
          this.viewList = null
        }
        this.selectedView = []
        this.selectedViewList = []
      })
    },
    previewClick(i) {
      window.resetView()
      window.StopViewAnimation()
      window.StartViewAnimation([window.R_config.initView, i.position], 1000)
    },
    deletes() {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteView()
      }).catch(() => {
      })
    },
    deleteView() {
      ApiService.views.deleteView({
        iDs: String(this.selectedView)
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getViewList()
        }
      })
    },
    editView(value) {
      window.ResetAllElement()
      ApiService.views.editView({
        id: this.selectedView[0],
        vName: value,
        position: window.GetView(),
        imgPath: window.GetImg(),
        mileageID: window.R_config.modelId
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getViewList()
        }
      })
    },
  }
}
</script>
<style lang="scss">
@import '../../common/css/color.scss';
.view-collect {
  .card {
    width: 500px;
    border: 0;
    .el-card__body {
      padding: 30px 20px;
      .btns {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
      }
      .view-main {
        display: flex;
        flex-wrap: wrap;
        height: 500px;
        overflow: auto;
        align-content: flex-start;
        padding: 5px 0;

        .view {
          // width: 110px;
          // min-height: 120px;
          box-sizing: border-box;
          padding: 5px 9px;
          border-radius: 5px;
          width: 33.3333%;
          box-sizing: border-box;
          // padding: 10px 5px;
          padding-top: 10px;
          position: relative;
          &:hover {
            box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48);
            border-radius: 2px;
          }
          img {
            width: 130px;
            height: 80px;
            display: block;
            margin: 10px auto;
            box-sizing: border-box;
            cursor: pointer;
          }
          .view-name {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-all;
            font-size: 12px;
            padding: 0 10px;
            margin-top: -5px;
            cursor: pointer;
            color: $font_color;
          }
          .view-check {
            position: absolute;
            top: 2px;
            right: 0;
            i {
              font-size: 24px;
            }
            .icon-sp_checked {
              color: #F3B231;
            }
            .icon-sp_uncheck {
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
      }

      .view-nodata {
        height: 500px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          width: 50%;
          line-height: 60px;
          color: #909399;
          font-size: 14px;
        }
      }
    }
  }
}
.el-scrollbar__wrap {
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mind/viewCollect.vue